import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputSignalField } from 'src/app/core/models/common';
import { SignalAppService, SignalQueryParams } from 'src/app/core/services/signalapp.service';
import { BaseModalComponent } from '../base-modals.component';
import { Constants } from 'src/app/core/models/constants';

@Component({
    selector: 'app-search-signal',
    standalone: false,
    templateUrl: './search-signal.component.html'
})
export class SearchSignalComponent implements OnInit {

    inputSignalFields: Array<InputSignalField> = [];
    initialInputSignalFields: Array<InputSignalField> = [];
    entityType: string = '';
    baseIndex: number = 10000;

    constructor(
        private readonly config: DynamicDialogConfig,
        private readonly signalAppService: SignalAppService,
        private readonly ref: DynamicDialogRef
    ) {

    }

    ngOnInit() {
        this.loadConfig();
        BaseModalComponent.setTabActionToCloseButton(this.baseIndex);
        BaseModalComponent.setBaseIndexToCloseButton(this.baseIndex);
    }

    private loadConfig() {
        this.entityType = this.config.data?.entityType;
        this.inputSignalFields = this.config.data?.inputSignalFields;
        this.initialInputSignalFields = this.inputSignalFields.map(field => ({ ...field }));
    }

    private getHttpParamsFromInputs(): SignalQueryParams {
        return this.inputSignalFields.reduce<Record<string, string>>((signalParams, inputField) => {
            if (inputField.inputValue && inputField.paramName) {
                const currentValue = signalParams[inputField.paramName];
                signalParams[inputField.paramName] = currentValue ? 
                    currentValue+Constants.SIGNAL_PARAM_SEPARATOR+inputField.inputValue : inputField.inputValue;
            }
            return signalParams;
        }, { entity_type: this.entityType });
    }

    reset(): void {
        this.inputSignalFields = this.initialInputSignalFields.map(field => ({ ...field }));
    }

    search(): void {
        this.signalAppService.runSignalQuery(this.getHttpParamsFromInputs());
        this.ref.close();
    }

    focusCloseButton(event: Event, reverse: boolean = false): void {
        BaseModalComponent.focusCloseButton(document, event, reverse);
    }

}

